<!--title -->
<app-modal-title
  [title]="'pages.medias.form.addTitle' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-flex-center flex-column">
      <div class="tw-w-[300px]">
        <!-- title -->
        <form-field
          [(value)]="mediaTitle"
          [control]="form?.get('mediaTitle')"
          [label]="'common.title'"
        >
        </form-field>

        <!-- upload file -->
        <app-file-uploader-box
          label="common.file"
          [controlName]="form?.get('file')"
          [maxFileSize]="1"
          sizeType="gb"
          acceptFile=".jpg,.jpeg,.png,.mp3,.mp4,.mkv,.pdf"
          (file)="getFile($event)"
        >
        </app-file-uploader-box>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="false"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
